import { Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmDialog } from 'primeng/confirmdialog';

@Component({
  selector: 'app-confirmation-dialog',
  imports: [CommonModule, ConfirmDialog],
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ConfirmationDialogComponent {}
